import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.module.scss';

class DesktopModal extends Component {
  dialog = React.createRef();
  container = document.createElement('div');

  componentDidMount() {
    document.documentElement.appendChild(this.container);
    this.previousFocus = document.activeElement;
    this.previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', this.handleKeyDown);
    this.dialog.current.focus();
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.documentElement.style.overflow = this.previousOverflow;
    document.documentElement.removeChild(this.container);
    if (this.previousFocus && document.documentElement.contains(this.previousFocus)) {
      this.previousFocus.focus();
    }
  }

  handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.props.onClose();
    }
    if (event.key === 'Tab') {
      const focusable = this.dialog.current.querySelectorAll('button:not([disabled]), a[href]');
      const firstElement = focusable[0];
      const lastElement = focusable[focusable.length - 1];
      const activeElement = document.activeElement;
      if (event.shiftKey && (activeElement === firstElement || activeElement === this.dialog.current)) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && (activeElement === lastElement || activeElement === this.dialog.current)) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  };

  handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      this.props.onClose();
    }
  };

  render() {
    return ReactDOM.createPortal(
      <div className={styles.desktopOverlay} onClick={this.handleBackdropClick}>
        <section
          className={styles.downloadModal}
          role="dialog"
          aria-modal="true"
          aria-label="Android安装教程"
          tabIndex={-1}
          ref={this.dialog}
        >
          <button className={styles.desktopClose} type="button" aria-label="关闭安装教程" onClick={this.props.onClose}>×</button>
          <div className="am-modal-content">
            <div className="am-modal-body">{this.props.children}</div>
          </div>
        </section>
      </div>,
      this.container,
    );
  }
}

export default DesktopModal;
